import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const base = `${API}/api/referral-portal`;
const opts = { withCredentials: true };

export const referralPortalApi = {
  specialisations: () => axios.get(`${base}/specialisations`, opts).then((r) => r.data),
  approvalWorkflow: () => axios.get(`${base}/approval-workflow`, opts).then((r) => r.data),
  providers: () => axios.get(`${base}/providers`, opts).then((r) => r.data),
  me: () => axios.get(`${base}/me`, opts).then((r) => r.data),
  myRequests: () => axios.get(`${base}/requests`, opts).then((r) => r.data),
  createRequest: (body) => axios.post(`${base}/requests`, body, opts).then((r) => r.data),
  getRequest: (id) => axios.get(`${base}/requests/${id}`, opts).then((r) => r.data),
  patientLetterPdfUrl: (id) => `${base}/requests/${id}/letter.pdf`,
  patientLetterPreviewUrl: (id) => `${base}/requests/${id}/letter/preview`,

  inbox: (status) =>
    axios.get(`${base}/inbox`, { ...opts, params: status ? { status } : {} }).then((r) => r.data),
  inboxOne: (id) => axios.get(`${base}/inbox/${id}`, opts).then((r) => r.data),
  startReview: (id) => axios.post(`${base}/inbox/${id}/start-review`, {}, opts).then((r) => r.data),
  ficDecision: (id, body) => axios.post(`${base}/inbox/${id}/fic`, body, opts).then((r) => r.data),
  saveLetter: (id, sections, signatureImage) =>
    axios.put(
      `${base}/inbox/${id}/letter`,
      {
        sections,
        ...(signatureImage !== undefined ? { signature_image: signatureImage } : {}),
      },
      opts,
    ).then((r) => r.data),
  issueLetter: (id) => axios.post(`${base}/inbox/${id}/issue`, {}, opts).then((r) => r.data),
  getMySignature: () => axios.get(`${base}/me/signature`, opts).then((r) => r.data),
  saveMySignature: (signatureImage) =>
    axios.put(`${base}/me/signature`, { signature_image: signatureImage }, opts).then((r) => r.data),
  doctorLetterPdfUrl: (id) => `${base}/inbox/${id}/letter.pdf`,
  doctorLetterPreviewUrl: (id) => `${base}/inbox/${id}/letter/preview`,
};
